import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { ForgotPasswordForm } from "@/features/auth/components/forgot-password-form"

const searchSchema = z.object({
  email: z.string().optional(),
  challenge: z.uuid().optional().catch(undefined),
})

export const Route = createFileRoute("/$organisation/_guest/forgot-password/")({
  validateSearch: searchSchema,
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  const { email, challenge } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <ForgotPasswordForm
      sentTo={email ?? ""}
      challengeId={challenge ?? null}
      onStartAgain={() => {
        void navigate({ search: {}, replace: true })
      }}
    />
  )
}
